"use client";

import React from "react";
import AnimatedLinkButton from "./AnimatedLinkButton";

const MachiHakoSection = () => {
  return (
    <div id="tobari" className="flex flex-col gap-8 mt-16">
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-3">
            <p className="font-bold text-lg">人を見ない。まちを見る。</p>
            <span className="inline-block px-3 py-1 text-xs font-semibold border border-neutral-400 text-neutral-500 rounded-full">
              PoC実施中
            </span>
          </div>
          <h3 className="font-bold text-2xl">
            匿名人流データプラットフォーム Tobari
          </h3>
        </div>
        <p className="text-base tracking-wide max-w-3xl">
          Tobariは、既存カメラに知覚を与え、匿名人流データで都市の動態をリアルタイムに可視化するプラットフォームです。
          映像はクラウドに送らず、端末内で処理。個人を特定せず、まちの流れだけを記録します。
        </p>
      </div>
      <div className="flex gap-4 flex-col md:flex-row">
        <AnimatedLinkButton href="https://tobari.io" isExternal>
          サービスサイトへ
        </AnimatedLinkButton>
        <AnimatedLinkButton href="/contact">お問い合わせ</AnimatedLinkButton>
      </div>
    </div>
  );
};

export default MachiHakoSection;
